// extracted by mini-css-extract-plugin
module.exports = {"LinkButton":"LinkButton_LinkButton__3Gw-y","LinkButton__large":"LinkButton_LinkButton__large__2dDxS","LinkButton__small":"LinkButton_LinkButton__small__2MXx-"};